import dayjs from "dayjs";
import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { DateRange } from "@/domains/common";
import {
  TransferRead,
  TransferService,
  TransferQueryParams,
  TransferCategory,
} from "@/domains/transfer";
import { RootState } from "@/stores";

interface OperatorTenantDepositState {
  loading: boolean;
  dateRange: DateRange;
  queryParams: TransferQueryParams;
  transfers: TransferRead[];
}

const initialState: OperatorTenantDepositState = {
  loading: false,
  dateRange: DateRange.day0,
  queryParams: {
    created_started_at: dayjs().startOf("day").toISOString(),
    created_stopped_at: dayjs().endOf("day").toISOString(),
  },
  transfers: [],
};

export const operatorTenantDepositSelects = {
  loading: (state: RootState) => state.operatorTenantDeposit.loading,
  dateRange: (state: RootState) => state.operatorTenantDeposit.dateRange,
  queryParams: (state: RootState) => state.operatorTenantDeposit.queryParams,
  transfers: (state: RootState) => state.operatorTenantDeposit.transfers,
};

export const operatorTenantDepositThunks = {
  list: createAsyncThunk(
    "operatorTenantDeposit/list",
    async (params: TransferQueryParams = {}) => {
      const res = await TransferService.list({
        ...params,
        category: TransferCategory.TenantDeposit,
      }).run();

      return res.data.msg;
    }
  ),
};

export const operatorTenantDepositSlice = createSlice({
  name: "operatorTenantDeposit",
  initialState,
  reducers: {
    setQueryParams: (state, action: PayloadAction<TransferQueryParams>) => {
      state.queryParams = action.payload;
    },
    setDateRange: (state, action: PayloadAction<DateRange>) => {
      state.dateRange = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(operatorTenantDepositThunks.list.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      operatorTenantDepositThunks.list.fulfilled,
      (state, action) => {
        state.loading = false;
        state.transfers = action.payload.transfers;
      }
    );
    builder.addCase(operatorTenantDepositThunks.list.rejected, (state) => {
      state.loading = false;
      state.transfers = [];
    });
  },
});

export const operatorTenantDepositActions = operatorTenantDepositSlice.actions;
